<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">{{ $route.meta.type }}</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="fetchData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        class="btn mb-4 md:mb-0 mr-1"
                        :to="{ name: `${$route.name}-add`} "
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        @click="handleView"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="showFilter = true"
                    >Filter</vs-button>
                    <vs-button
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="import_export"
                        @click="exportData"
                    >Export</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="handleView"
                :animateRows="false"
                :floatingFilter="false"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination
                :total="totalPage"
                v-model="currentPage"
                :max="7"
            ></vs-pagination>
        </vx-card>
        <vs-prompt buttons-hidden title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <div class="vx-col w-full mb-2">
                    <vs-input class="w-full" v-model="filter.id" label="ID"/>
                </div>
                <div class="vx-col w-full mb-2">
                    <vs-input class="w-full" v-model="filter.reference" label="Reference"/>
                </div>
                <div class="vx-col w-full mb-2">
                    <vs-input class="w-full" v-model="filter.client_id" label="Client ID"/>
                </div>
                <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
                    <vs-button color="primary" @click="fetchData">Filter</vs-button>
                </vs-row>
            </div>
        </vs-prompt>
    </div>
</template>
<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            gridOptions: {},
            data: [],
            columnDefs: null,
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            selectedId: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            filter: {
                client_id: '',
                id: '',
                reference: '',
                type: this.$route.meta.type
            },
            showFilter: false
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridOptions.api.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        handleView() {
            this.$router.push({
                name: `${this.$route.meta.slug}-view`,
                params: {
                    id: this.selectedId
                }
            });
        },
        fetchData() {
            this.data = [];
            this.isLoading = true
            Promise.all([
                this.$http.post("valueaddedservice?page=" + this.currentPage, this.filter)
            ])
                .then(
                    this.$http.spread(res => {
                        this.isLoading = false
                        this.data = res.data.data
                        this.totalPage = res.data.last_page;
                        this.dataFrom = res.data.from || 0;
                        this.dataTo = res.data.to || 0;
                        this.dataTotal = res.data.total;
                        this.showFilter = false;
                    })
                )
                .catch(err => console.log(err))
        },
        exportData() {
            this.isLoading = true;
            this.$http.post('valueaddedservice/export', this.filter, { responseType: "blob" })
            .then(response => {
                this.isLoading = false;
                var blob = new Blob([response.data], {
                    type: "application/pdf"
                });
                
                saveAs(blob, "value_added_service_export.xlsx");
            })
            .catch(e => this.handleError(e, true));
        }
    },
    computed: {},
    mounted() {
        this.fetchData();
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Production ID",
                field: "id",
                width: 120
            },
            {
                headerName: "Client ID",
                field: "client.client_code",
                width: 120
            },
            {
                headerName: "Warehouse ID",
                field: "warehouse.warehouses_code",
                width: 120
            },
            {
                headerName: "Reference",
                field: "reference",
                width: 120
            },
            {
                headerName: "Production Date",
                field: "production_date",
                width: 120
            },
            {
                headerName: "Release Date",
                field: "release_date",
                width: 120
            },
            {
                headerName: "Production Status",
                field: "status.name",
                width: 120
            },
        ];
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>